module.exports = __webpack_public_path__ + "static/team-19-2a5c0e15cff1410d0194fd12d49bdda9.jpg";